var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-details"},[_c('div',{staticClass:"index-title"},[_vm._v("字体许可证副本")]),_vm._v(" "),_c('div',{staticClass:"index-con",domProps:{"innerHTML":_vm._s(_vm.detailsConten)}}),_vm._v(" "),_c('div',{staticClass:"submit",on:{"click":_vm.handleClick}},[_vm._v(" 关闭 ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151e37f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/person/fontBase.vue
// module id = null
// module chunks = 